<template>
  <div>
    <x-grid :id="'formList'"
            :rowId="rowId"
            :pager-config="pagerConfig"
            :form-config="formConfig"
            :url="url"
            :columns="columns"
            :checkbox-config="checkboxConfig"
            :toolbar-config="toolbarConfig"
            :print-config="printConfig"
            :export-config="exportConfig"
            ref="grid"
            :cellClick="chooseRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
      </template>
    </x-grid>

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter";
import api from '@/services/api';
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

// import detailForm from "@/pages/web/comm/ecSettingsManage/ecSettingsManageDetail";

const fac = XGrid.factory;

//列表接口
const url = api.comm.LOG;

//主键
const rowId = "id";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("username", "操作人", 200),
  fac.makeColumn("operation", "操作行为", 300),
  fac.makeColumn("createDate", "操作时间", 200),
]


// 预加载函数 用来加载 列表查询中的通用代码 或其他代码
const formConfig = fac.makeFormConfig(columns, [
  {field: 'username'},
  {field: 'operation'}
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  delData: false,
  export: true,
  import: false,

  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);
export default {
  mixins: [GridMixin],
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   delRow: 'DELETE'
  // },
  components: {
  },
  data() {
    return {
      exportUrl:api.comm.LOGEXPORT,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  methods: {}
}
</script>

<style scoped>
</style>